import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { IconButton } from 'seagull';
import { Box } from 'seagull/components/Layout';
import { ActivityLog } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useHasUnseenNotifications } from '~/tasks-drawer/hooks/useHasUnseenNotifications';
import { useTasksDrawer } from '~/tasks-drawer/tasksDrawerStore';
import styles from './TasksTriggerButton.module.scss';
export const GetTasksTriggerButtonTID = (parentTestId)=>getTestIds(parentTestId);
export const TasksTriggerButton = (param)=>{
    let { testId } = param;
    const { t: texts } = useLocaleKeys('tasksDrawer');
    const { isDrawerOpen, toggle } = useTasksDrawer();
    const hasUnseenNotifications = useHasUnseenNotifications();
    const { TasksTriggerButtonTID } = useMemo(()=>GetTasksTriggerButtonTID(testId), [
        testId
    ]);
    const onToggle = useCallback(()=>toggle(), [
        toggle
    ]);
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.root,
        alignItems: "center",
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                bi: {
                    name: isDrawerOpen ? 'tasks_drawer_close' : 'tasks_drawer_open'
                },
                tooltip: {
                    title: texts.trigger.tooltip()
                },
                skin: isDrawerOpen ? 'primaryTransparentBoxed' : 'transparent',
                testId: TasksTriggerButtonTID.Root(),
                onClick: onToggle,
                children: /*#__PURE__*/ _jsx(ActivityLog, {})
            }),
            hasUnseenNotifications && /*#__PURE__*/ _jsx(Box, {
                className: styles.dot,
                testId: TasksTriggerButtonTID.Dot()
            })
        ]
    });
};
